import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@material-ui/lab';
import { Grid} from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import Pagination from '@material-ui/lab/Pagination';
import { validatePayroll } from './validatePayroll';

const TablePayroll = props => {
    const { dataPaginate, count, page, onChangePagination, setDocumentIsCorrect } = props
    const [dataupload, setDataUpload ] = useState([])
    const mount = () => {
        const unmount = () => {
            // (dataPaginate)
            //Validar Datos
            let dataFilter = dataPaginate
            validatePayroll(dataFilter, setDocumentIsCorrect)
            setDataUpload(dataFilter)
            
        }
        return unmount()
    }
    useEffect(mount, [dataPaginate])
    if (dataPaginate.length > 0) {
        return  <div className = { "container" }>
                <Grid item xs={12} md={12} lg = {12}>
                    <Table className = {"table"}>
                        <Thead>
                            <Tr>
                                <Th>Identificación</Th>
                                <Th>Tipo Identificación</Th>
                                <Th>Nombres</Th>
                                <Th># Cuenta</Th>
                                <Th className = { "colunmvalue"}>Monto</Th>
                                <Th style={{width: '200px'}}>Institución</Th>
                                <Th>Validacion</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            { 
                                
                                dataupload.map((row, index) => (
                                    <Tr key={row.Identificacion}>
                                        <Td>{row.Identificacion}</Td>
                                        <Td>{row.TipoIdentificacion}</Td>
                                        <Td>{row.NombreApellido}</Td>
                                        <Td>{row.NumeroCuentaDestino}</Td>
                                        <Td>$ {row.Valor}</Td>
                                        <Td>{row.Institucion || 'COAC CAJA'}</Td>
                                        <Td style = {{ color: row.validate !== 'CORRECTO' ? 'red': '#8eab40', fontWeight:'bold'}} >{row.validate}</Td>
                                    </Tr>
                                ))
                                
                            }
                            
                        </Tbody>
                    </Table>
                    <br/>
                    <Pagination
                        count = { count } 
                        color = "primary" 
                        page = { page }
                        onChange = { onChangePagination }
                    />
                </Grid>
                </div>
    } else {
        return <Alert severity="info">No se ha cargado ninguna información.</Alert>
    }
};

TablePayroll.propTypes = {
    dataPaginate: PropTypes.array.isRequired,
};

export default TablePayroll;